import React from 'react';

const ContextBanner = ({ tier, selectedChildIds, accentClasses, bannerText }) => {
  if (!bannerText) return null;

  const icon = tier === 'mine' ? '\uD83D\uDCD6' : '\uD83D\uDC76';
  const bannerBg = (tier === 'child' && selectedChildIds.length === 0)
    ? 'bg-gray-50 border-gray-200'
    : `${accentClasses.bg} ${accentClasses.border}`;

  return (
    <div className={`flex items-start gap-3 p-4 rounded-xl border ${bannerBg}`}>
      <span className="text-xl flex-shrink-0">{icon}</span>
      <p className="text-base sm:text-sm text-text-medium leading-relaxed">{bannerText}</p>
    </div>
  );
};

export default ContextBanner;
